import DatabaseIcon from '@mui/icons-material/Storage';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { ExecuteQueryToolArguments } from 'services/types/ticket';

import MessageWrapper from './MessageWrapper';

interface Props {
  args: string;
}

const ExecuteQueryToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: ExecuteQueryToolArguments;

  try {
    parsedArgs = JSON.parse(args) as ExecuteQueryToolArguments;
  } catch (_error) {
    return (
      <MessageWrapper caption="Herramienta de Base de Datos" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Ejecutar consulta SQL" align="left">
      <Box>
        <Box
          sx={{
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              <DatabaseIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
              Consulta a PostgreSQL:
            </Typography>
          </Box>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              bgcolor: 'grey.50',
              maxHeight: '200px',
              overflow: 'auto',
              fontFamily: 'monospace',
              fontSize: '0.875rem',
              whiteSpace: 'pre-wrap',
              lineHeight: 1.4,
            }}
          >
            {parsedArgs.sqlQuery}
          </Paper>
        </Box>
      </Box>
    </MessageWrapper>
  );
};

export default ExecuteQueryToolComponent;
